import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import CustomerSiderBar from './user/CustomerSiderBar';
import HeaderCustomer from './user/HeaderCustomer';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../../utils/constants';

class AdminLayout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            notificationSystem: {},
            width: 0, height: 0
        }
    }

    static isSidebarOpen() {
        return document
            .querySelector('.cr-sidebar')
            .classList.contains('cr-sidebar--open');
    }

    componentWillReceiveProps({ breakpoint }) {
        if (breakpoint !== this.props.breakpoint) {
            this.checkBreakpoint(breakpoint);
        }
    }

    componentDidUpdate(prevState) {
        // console.log(prevState)
        // if ( prevState.width !== this.state.width ) {
        //     console.log("da den rồi")
        // }
    }

    componentWillUnmount() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentDidMount() {
        this.checkBreakpoint(this.props.breakpoint);
    }

    handleContentClick = event => {
    // close sidebar if sidebar is open and screen size is less than `md`
        if (
          AdminLayout.isSidebarOpen() &&
          (this.props.breakpoint === 'xs' ||
            this.props.breakpoint === 'sm' ||
            this.props.breakpoint === 'md')
        ) {
          this.openSidebar('close');
        }
    };

    checkBreakpoint(breakpoint) {
        switch (breakpoint) {
            case 'xs':
            case 'sm':
            case 'md':
                return this.openSidebar('close');
            case 'lg':
            case 'xl':
            default:
                return this.openSidebar('open');
        }
    }

    openSidebar(openOrClose) {
        if (openOrClose === 'open') {
            document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        }
        else {
            document.querySelector('.cr-sidebar').classList.remove('cr-sidebar--open');
        }
    }

    render() {
        // console.log(this.state.width)
        const { children } = this.props;
        return (
            <main className="cr-app bg-light">
                {
                    this.props.menu === 'cloudzoneAdmin-admin-menuAdmin' ? (
                        <>
                            <Sidebar />
                            <div className='cr-content container-fluid'>
                                <Header />
                                <div className='cr-page px-3'>
                                    {children}
                                </div>
                                <Footer />
                            </div>
                        </>
                    ) : (
                        <>
                            <CustomerSiderBar />
                            <div className='cr-content container-fluid'>
                                <HeaderCustomer />
                                <div className='cr-page px-3'>
                                    {children}
                                </div>
                                <Footer />
                            </div>
                        </>
                    )
                }
                <NotificationSystem
                  dismissible={false}
                  ref={notificationSystem =>
                      // eslint-disable-next-line react/no-direct-mutation-state
                    (this.state.notificationSystem = notificationSystem)
                  }
                  style={NOTIFICATION_SYSTEM_STYLE}
                />
            </main>
        );
    }
}


export default AdminLayout;
